// extracted by mini-css-extract-plugin
export default {"wrapper":"B2CBanner_wrapper__zJkxz","info":"B2CBanner_info__1HkGy","dark":"B2CBanner_dark__QVOLn","likeAnimation":"B2CBanner_likeAnimation__YyQfx"};